import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { getParam } from 'controls/utils';
import { useSelector, useDispatch } from 'react-redux';
import { showSuccess } from 'actions/utils';
import { getAllUserData } from 'actions/user';
import InlineSpinner from 'components/atoms/Spinner/InlineSpinner';
import { Header } from 'components/atoms/Header/Header';
import { strings } from 'components/checkout/billing/strings';
import { Language } from 'language/Language';
import { isCountriesTax } from '../../../countriesTax';
import './_CheckoutBilling.scss';

const CheckoutBilling = ({ history }) => {
  const purchasetype = getParam('type');
  const isSubscription = purchasetype === 'subscription';
  const { entitlement } = useSelector((state) => state);

  // this is because wordpress changes the value
  if (process.env.REACT_APP_PADDLE_ENVIRONMENT === 'sandbox') {
    window.Paddle.Environment.set('sandbox');
  }
  const { userInfo } = useSelector((state) => state);
  const {
    priceProduct, countryUser, product, subscription,
  } = useSelector((state) => state.siteInfo);
  const userSubscription = useSelector((state) => state.subscription);

  const productPrices = isSubscription ? subscription?.prices : priceProduct;

  const { Paddle } = window;
  const dispatch = useDispatch();
  const language = Language();

  const handleSuccess = async () => {
    setTimeout(async () => {
      showSuccess({
        title: 'PURCHASE SUCCESSFUL.',
        text: `You can find your license in the ${isSubscription ? 'Subscription' : 'Orders'} section`,
        className: 'modal-item',
      })
        .then(async () => {
          await dispatch(getAllUserData());
          if (!isSubscription) {
            history.push(`${language === 'japan' ? '/jp/私のアカウント' : '/my-account'}/orders`);
          } else {
            history.push('/my-account/subscriptions');
          }
        });
    }, 2000);
  };

  const openCheckout = () => {
    Paddle.Checkout.open({
      product: isSubscription ? subscription.id : product,
      email: userInfo.email,
      country: countryUser,
      successCallback: handleSuccess,
      allowQuantity: true,
    });
  };

  const hasActiveSubscription = userSubscription?.status === 'Active';
  const expirationDate = new Date(entitlement?.expiration);
  const now = new Date();

  const isValidEntitlement = expirationDate >= now;

  useEffect(() => {
    if (isSubscription && hasActiveSubscription) {
      history.push('/my-account/subscriptions');
    }
    if (entitlement && isValidEntitlement) {
      history.push('/my-account/products');
    }

    if (!userInfo) {
      history.push('/my-account?redirectTo=checkout');
    }
  }, [history, isSubscription, hasActiveSubscription, entitlement, isValidEntitlement, userInfo]);

  return (
    <div className='checkout-content'>
      <div className='checkout-order'>
        <h3 style={{ marginBottom: '50px' }}>{strings[language].title}</h3>
        <div className='checkout-order__group'>
          <div>
            <h3>{strings[language].product}</h3>
          </div>
          <div>
            <h3 style={{ textAlign: 'right' }}>{strings[language].subtotal}</h3>
          </div>
        </div>
        <div className='checkout-payment__data'>
          <div className='checkout-order__group'>
            <span style={{ width: '60%' }}>
              WalkMix Creator
              {' '}
              <strong>
                x1
              </strong>
            </span>
            {productPrices
              ? <h3 className='checkout-payment__price'>{productPrices.net}</h3>
              : <InlineSpinner />}
          </div>
          <div className='checkout-order__group' style={{ marginTop: '20px' }}>
            <span>{strings[language].subtotal}</span>
            {productPrices
              ? <h3 className='checkout-payment__price'>{productPrices.net}</h3>
              : <InlineSpinner />}
          </div>
          {productPrices && productPrices.tax_included
            && (
              <div className='checkout-order__group' style={{ marginTop: '20px' }}>
                <span>{strings[language].taxes}</span>
                {productPrices
                  ? <h3 className='checkout-payment__price'>{productPrices.tax}</h3>
                  : <InlineSpinner />}
              </div>
            )}
        </div>
        <div className='checkout-order__group'>
          <Header text={strings[language].total} />
          {productPrices
            ? (<h2 className='checkout-payment__price'>{productPrices.gross}</h2>)
            : <InlineSpinner />}
        </div>
      </div>
      {isCountriesTax(countryUser)
          && (
            <div className='' style={{ marginTop: '20px' }}>
              <p>{`Pricing is listed in ${countryUser} and does not include applicable taxes.`}</p>
              <p>Pricing at checkout will be local currency with applicable taxes applied.</p>
            </div>
          )}
      <button
        type='submit'
        className='main-btn'
        style={{ marginBottom: '50px' }}
        onClick={openCheckout}
      >
        {strings[language].button}
      </button>
      {
        !isSubscription && (
          <p style={{ fontSize: '1.2em', textAlign: 'center' }}>
            <strong>{strings[language].coupon}</strong>
            {strings[language].couponInfo}
          </p>
        )
      }
    </div>
  );
};

CheckoutBilling.propTypes = {
  history: PropTypes.object,
};

export default CheckoutBilling;
